import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

const GlobalNotification = ({ userId, userRole }) => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  // 🔹 Fetch notifications
  useEffect(() => {
    if (!userId || !userRole) return;

    const roleMap = {
      USER: "Talent",
      COMPANY: "Director",
      ADMIN: "Admin",
    };

    const mappedRole = roleMap[userRole] || userRole;

    const fetchNotifications = async () => {
      try {
        const res = await api.get(
          ENDPOINTS.getNotifications({ userId, userRole: mappedRole })
        );

        const data = res?.data?.data || [];

        const filtered = Array.isArray(data)
          ? data.filter((n) => n.activeFlag !== false)
          : [];

        setNotifications(filtered);
      } catch (err) {
        console.error("Notification fetch failed", err);
      }
    };

    fetchNotifications();
  }, [userId, userRole]);

  // 🔹 Open when notifications arrive
  useEffect(() => {
    if (notifications.length > 0) {
      setOpen(true);
    }
  }, [notifications]);

  // 🔹 Manual close ONLY (with API)
  const handleClose = async () => {
    const current = notifications[0];

    setOpen(false);

    // remove current notification after animation
    setTimeout(() => {
      setNotifications((prev) => prev.slice(1));
    }, 200);

    // call backend dismiss
    if (current?.id) {
      try {
        await api.post(ENDPOINTS.dismissNotification(), {
          userId: Number(userId),
          notificationId: current.id,
        });
      } catch (err) {
        console.error("Dismiss failed", err);
      }
    }
  };

  // 🔹 Nothing to render
  if (!notifications.length) return null;

  const notification = notifications[0];

  return (
    <Collapse in={open}>
      <Alert
        severity={notification?.type || "info"}
        sx={{ mb: 2 }}
        action={
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{notification?.title || "Notification"}</AlertTitle>
        {notification?.message || "No message"}
      </Alert>
    </Collapse>
  );
};

export default GlobalNotification;